import { connect } from 'react-redux'
import VersionsView from '../components/VersionsView'
import {
  getAvailableVersions,
  pinVersion,
  rolloutVersion,
  rollbackVersion,
  versionStatus
} from '../../../store/versions'

const mapDispatchToProps = {
  getAvailableVersions,
  pinVersion,
  rolloutVersion,
  rollbackVersion,
  versionStatus
}

const mapStateToProps = (state) => {
  return {
    stagingValues: state.versions.staging,
    productionValues: state.versions.production
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionsView)



// WEBPACK FOOTER //
// ./src/routes/Versions/containers/VersionContainer.js